import { useState } from 'react';

export default function PersonModal({ person, onClose }) {
  const [zoom, setZoom] = useState(false);
  return (
    <>
    <div className="modal-overlay" onClick={e => e.target===e.currentTarget && onClose()}>
      <div className="modal fade-in">
        <div className="modal-header">
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <div
              className="table-avatar"
              style={{ width:40, height:40, fontSize:13, cursor: person.photo_url ? 'zoom-in' : 'default' }}
              onClick={() => person.photo_url && setZoom(true)}
            >
              {person.photo_url ? <img src={person.photo_url} alt={person.name} /> : person.initials}
            </div>
            <h3>{person.name}</h3>
          </div>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="role-badge">{person.role}</div>
          {person.dept_name && <div style={{ fontSize:12, color:'var(--mid)', marginBottom:12 }}>Departamento: <strong style={{ color:'var(--dark)' }}>{person.dept_name}</strong></div>}
          {person.email && <div className="modal-email"><span>✉</span><a href={`mailto:${person.email}`}>{person.email}</a></div>}
          {person.bio && <p style={{ fontSize:13, color:'var(--mid)', lineHeight:1.75, marginBottom:14 }}>{person.bio}</p>}
          {person.functions?.length > 0 && (
            <><p className="modal-sect-title">Funciones principales</p>
            <ul className="func-list">
              {person.functions.map((f,i) => (
                <li key={i}><div><strong>{f.title}</strong>{f.description && <><br/>{f.description}</>}</div></li>
              ))}
            </ul></>
          )}
        </div>
      </div>
    </div>
    {zoom && person.photo_url && (
      <div
        className="modal-overlay"
        style={{ zIndex:300, background:'rgba(0,0,0,.85)' }}
        onClick={e => e.target===e.currentTarget && setZoom(false)}
      >
        <img
          src={person.photo_url}
          alt={person.name}
          style={{ maxWidth:'90vw', maxHeight:'85vh', borderRadius:8, boxShadow:'0 20px 60px rgba(0,0,0,.5)', objectFit:'contain' }}
        />
        <button
          className="modal-close"
          style={{ position:'fixed', top:20, right:20 }}
          onClick={() => setZoom(false)}
        >×</button>
      </div>
    )}
    </>
  );
}
